<template>
  <div class="row">
    <!-- Smart Transactions Section -->
    <div class="col-12">
      <div class="card mb-4">
        <div class="card-header pb-0">
          <div class="row">
            <div class="col-12 d-flex d-flex justify-content-between align-items-center">
              <h6 class="mb-0">Smart Transactions</h6>
              <button
                class="btn bg-gradient-dark mb-0 ms-auto"
                :disable="exportLoading"
                @click="exportTransactions"
              >
                <i class="fas fa-download" v-if="!exportLoading"></i>
                <div
                    class="spinner-border spinner-border-sm"
                    role="status"
                    v-if="exportLoading"
                >
                    <span class="sr-only">Loading...</span>
                </div>
                Export
              </button>
            </div>
          </div>
        </div>
        <hr class="mx-3" style="border-top: 1px solid !important" />

        <transaction-header />
        <!-- <hr class="horizontal dark mt-3"> -->
        <transaction-list />
      </div>
    </div>
  </div>
</template>

<script>
import transactionHeader from "./components/header.vue";
import transactionList from "./components/transactionList.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    "transaction-header": transactionHeader,
    "transaction-list": transactionList,
  },
  computed: {
    ...mapState({
      filter: (state) => state.retailerController.transactionsFilter,
      loading: (state) => state.retailerController.transactionsLoading,
      exportLoading: (state) =>
        state.retailerController.transactionsExportLoading,
    }),
  },
  methods: {
    ...mapActions({
      getTransactions: "retailerController/GetTransactions",
      exportTransactions: "retailerController/ExportTransactions",
    }),
  },
};
</script>

<style>
</style>